var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopilotIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6243 10.3361C6.56478 10.1054 6.44453 9.89484 6.27605 9.72636C6.10757 9.55788 5.89702 9.43762 5.6663 9.3781L1.5763 8.32344C1.50652 8.30363 1.44511 8.2616 1.40138 8.20373C1.35765 8.14586 1.33398 8.07531 1.33398 8.00277C1.33398 7.93023 1.35765 7.85968 1.40138 7.80181C1.44511 7.74394 1.50652 7.70191 1.5763 7.6821L5.6663 6.62677C5.89693 6.56731 6.10743 6.44715 6.2759 6.2788C6.44438 6.11044 6.56468 5.90003 6.6243 5.66944L7.67897 1.57944C7.69857 1.50938 7.74056 1.44766 7.79851 1.4037C7.85647 1.35974 7.92722 1.33594 7.99997 1.33594C8.07271 1.33594 8.14346 1.35974 8.20142 1.4037C8.25938 1.44766 8.30136 1.50938 8.32097 1.57944L9.37497 5.66944C9.43449 5.90015 9.55474 6.1107 9.72322 6.27918C9.8917 6.44766 10.1023 6.56792 10.333 6.62744L14.423 7.68144C14.4933 7.70084 14.5553 7.74278 14.5995 7.80082C14.6437 7.85887 14.6677 7.92981 14.6677 8.00277C14.6677 8.07573 14.6437 8.14667 14.5995 8.20472C14.5553 8.26276 14.4933 8.3047 14.423 8.3241L10.333 9.3781C10.1023 9.43762 9.8917 9.55788 9.72322 9.72636C9.55474 9.89484 9.43449 10.1054 9.37497 10.3361L8.3203 14.4261C8.3007 14.4962 8.25871 14.5579 8.20075 14.6018C8.1428 14.6458 8.07205 14.6696 7.9993 14.6696C7.92656 14.6696 7.85581 14.6458 7.79785 14.6018C7.73989 14.5579 7.69791 14.4962 7.6783 14.4261L6.6243 10.3361Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 2V4.66667",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.33594H12",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66797 11.3359V12.6693",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 12H2",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopilotIconWhite);
export default __webpack_public_path__ + "static/media/CopilotIconWhite.924e30d19990b7c98de11c69093081e4.svg";
export { ForwardRef as ReactComponent };